import { Button, Space } from "antd";
import { useSelector } from "react-redux";
import { selectUser } from "redux/slices/userSlice";
import K from "utilities/constants";
import {
  convertIntoDashUSFormat,
  formatDisplayTime,
} from "utilities/dateUtility";
import { isPermissionPresent } from "utilities/generalUtility";
import { CandidateFieldValue } from "../candidateFieldValue/candidateFieldValue";

export default function DisplayEditableDate({
  dateString,
  onEdit,
  isEditable = true,
  isTime = false,
  isOtherItem = false,
  itemType = K.EditComponentType.CheckBox,
  disabled = false,
}) {
  const userRoles = useSelector(selectUser).roles;

  const showEditButton =
    isEditable && isPermissionPresent(K.Permissions.EditCandidate, userRoles);

  return (
    <Space size={4} style={{ minHeight: 24 }}>
      <CandidateFieldValue>
        {isOtherItem ? (
          <>
            {itemType === K.EditComponentType.CheckBox
              ? dateString
                ? "Yes"
                : "No"
              : dateString}
          </>
        ) : !isTime ? (
          convertIntoDashUSFormat(dateString, false)
        ) : (
          formatDisplayTime(dateString)
        )}
      </CandidateFieldValue>
      {showEditButton && (
        <Button
          style={{ width: 16, height: 16 }}
          onClick={onEdit}
          type="link"
          disabled={disabled}
          icon={<i className="icon-edit" />}
        />
      )}
    </Space>
  );
}
